import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { BaseCmsComponent } from '@kion/data-models';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'kion-cms-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements AfterViewInit{
  @Input() component: BaseCmsComponent;

  @ViewChild('element') element: ElementRef;

  constructor(private route: ActivatedRoute) { }

  ngAfterViewInit(): void {
    if (this.component.anchor) {
      if (this.route.snapshot.fragment === this.component.anchor) {
        this.element.nativeElement.querySelector('.accordion-list-item-container')?.click();
        this.element.nativeElement.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }
  }
}
